import { twMerge } from 'tailwind-merge';
import cx from 'classnames';

export type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  variant?: 'light' | 'dark';
};

export default function Spinner({ size = 'xl', className, variant = 'dark' }: SpinnerProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
      className={twMerge(
        cx({
          'h-[16px] w-[16px]': size === 'sm',
          'h-[24px] w-[24px]': size === 'md',
          'h-[32px] w-[32px]': size === 'lg',
          'h-[40px] w-[40px]': size === 'xl',
        }),
        className,
      )}
    >
      <circle
        cx="5"
        cy="20"
        r="5"
        className={cx('opacity-[0.16] animate-flash', {
          'fill-neutral-0': variant === 'dark',
          'fill-neutral-100': variant === 'light',
        })}
      />
      <circle
        cx="20"
        cy="20"
        r="5"
        className={cx('opacity-[0.16] animate-flash  animation-delay-[400ms]', {
          'fill-neutral-0': variant === 'dark',
          'fill-neutral-100': variant === 'light',
        })}
      />
      <circle
        cx="35"
        cy="20"
        r="5"
        className={cx('opacity-[0.16] animate-flash animation-delay-[800ms]', {
          'fill-neutral-0': variant === 'dark',
          'fill-neutral-100': variant === 'light',
        })}
      />
    </svg>
  );
}
